import React from "react";

// Steps 1-3 are the same for both services; step 4 (what is delivered) follows the chosen request
export const stepsFor = (t, kind) => t.tutorial.steps.map((s, i) => (i === 3 && kind === "executive" ? t.tutorial.step4Executive : s));

export const RequestKindToggle = ({ t, value, onChange, dark = false, testid = "request-kind" }) => (
  <div data-testid={testid}>
    <p className={`font-mono text-[10.5px] uppercase tracking-[0.12em] mb-2 ${dark ? "text-cream/70" : "text-inksoft"}`}>{t.tutorial.kindLabel}</p>
    <div role="radiogroup" aria-label={t.tutorial.kindLabel} className="inline-flex rounded-sm border border-ink/15 bg-white/60 p-0.5">
      {["concept", "executive"].map((k) => (
        <button key={k} type="button" role="radio" aria-checked={value === k} data-testid={`${testid}-${k}`} onClick={() => onChange(k)}
          className={`px-4 h-9 rounded-sm font-mono text-[11px] uppercase tracking-[0.1em] transition-colors ${value === k ? "bg-ink text-cream" : "text-inksoft hover:text-ink"}`}>
          {t.tutorial.kinds[k]}
        </button>
      ))}
    </div>
  </div>
);
